import {
    Avatar, Space, Table, Typography,
} from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PaginatorType } from '../../../types/paginator';

interface IWorkspaceBusinessesTableProps {
    uniqueID: string | undefined;
    businesses: {
        data: any[];
        loading: boolean;
        count: number;
        paginator: PaginatorType;
    };
    fetchBusinesses: (paginator: PaginatorType) => void;
}

const { Text } = Typography;

export const WorkspaceBusinessesTable = ({ uniqueID, businesses, fetchBusinesses }: IWorkspaceBusinessesTableProps) => {
    const { deliveries, loading: dpLoading } = useSelector((state: any) => state.deliveries);

    const handleTableChange = (pagination: any) => {
        const newPaginator = {
            ...businesses.paginator,
            skip: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
        };
        fetchBusinesses(newPaginator);
    };

    const columns = [
        {
            title: 'Business ID',
            dataIndex: 'userUniqueID',
            key: 'userUniqueID',
            render: (userUniqueID: string, business: any) => (
                <Link style={{ color: '#08d108' }} to={`/v2/business/${business._id}`}>
                    {userUniqueID}
                </Link>
            ),
        },
        {
            title: 'Creation Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (createdAt: string, business: any) => (
                <Space size={4}>
                    <Text>
                        {moment(createdAt).format('DD MMM YYYY')}
                    </Text>
                </Space>
            ),
        },
        {
            title: 'Hour of Creation',
            dataIndex: 'hour',
            key: 'hour',
            render: (createdAt: string) => (
                <Text>
                    {moment(createdAt).format('HH:mm')}
                </Text>
            ),
        },
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            key: 'companyName',
        },
        {
            title: 'Contact Name',
            dataIndex: '',
            key: 'contactName',
            render: (data: any) => `${data.name} ${data.lastName}`,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Delivery Providers',
            dataIndex: 'externalAPIConfiguration',
            key: 'externalAPIConfiguration',
            render: (externalAPIConfiguration: any) => {
                const { deliveryProviders } = externalAPIConfiguration;
                const activeDeliveryProviders = deliveryProviders.filter((dp: any) => dp.isActive);
                return (
                    <Avatar.Group>
                        {activeDeliveryProviders.map((dp: any) => {
                            const keyName = (dp.keyName || dp.name);
                            const delivery = dpLoading ? {} : deliveries.find((delivery: any) => delivery.keyName === keyName);
                            return (
                                <Avatar
                                    key={keyName}
                                    style={{ borderColor: '#212845', backgroundColor: '#1a1f36' }}
                                    src={delivery?.image}
                                />
                            );
                        })}
                    </Avatar.Group>
                );
            },
        },
    ];

    return (
        <div>
            <Table
                dataSource={businesses.data}
                columns={columns}
                loading={businesses.loading}
                rowKey="_id"
                scroll={{ x: 800 }}
                pagination={{
                    total: businesses.count,
                    current: ((businesses.paginator.skip ?? 0) / businesses.paginator.limit) + 1,
                    pageSize: businesses.paginator.limit,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
                }}
                onChange={handleTableChange}
            />
        </div>
    );
};
